import React, { Component } from "react";
import styles from "./claimDeskStatsStyle.less";
import { Row, Col } from "antd";

const COLORS = ["#16a34a", "#ea580c", "#2563eb", "#7c3aed", "#d97706", "#059669", "#2563eb", "#4f46e5", "#c026d3", "#e11d48"];

class ClaimDeskStats extends Component {
    state = {
        enrollmentStats: {
            "Visa Approved Students": 0,
            "Unenrolled Students": 0,
            "Enrolled Students": 0,
            "Enrollment due": 0,
        },

        invoiceStats: {
            "Invoices not due yet": 0,
            "Invoices due for generation": 0,
            "Invoices due for Review": 0,
            "Invoices paid not updated": 0,
        },

        statusStats: {
            "Raised PI Invoices": 0,
            "Raised FI Invoices": 0,
            "Submitted to Uni": 0,
            "Approved by Uni": 0,
            "Paid by Uni": 0,
            "Cleared": 0
        },

        enrollmentStatusArr: [
            { statusName: 'Visa Approved Students', count: 10 },
            { statusName: 'Unenrolled Students', count: 20 },
            { statusName: 'Enrolled Students', count: 12 },
            { statusName: 'Enrollment due', count: 5 }
        ],

        invoiceStatsArr: [
            { statusName: 'Invoices not due yet', count: 15 },
            { statusName: 'Invoices due for generation', count: 8 },
            { statusName: 'Invoices due for Review', count: 6 },
            { statusName: 'Invoices paid not updated', count: 4 }
        ],

        statusStatsArr: [
            { statusName: 'Raised PI Invoices', count: 18 },
            { statusName: 'Raised FI Invoices', count: 14 },
            { statusName: 'Submitted to Uni', count: 11 },
            { statusName: 'Approved by Uni', count: 9 },
            { statusName: 'Paid by Uni', count: 7 },
            { statusName: 'Cleared', count: 5 }
        ]
    }

    render() {
        let { enrollmentStats, invoiceStats, statusStats, enrollmentStatusArr, invoiceStatsArr, statusStatsArr } = this.state;
        const getStatCard = ({ statusName, count }, index, spanSize) => {
            let key = statusName;
            const color = COLORS[index % COLORS.length];
            return (
                <Col
                    key={key}
                    span={spanSize}
                    style={{ marginBottom: "1rem" }}
                >
                    <div
                        className={styles.statCard}
                        style={{
                            padding: "15px 20px",
                            background: "#fff",
                            borderRadius: "10px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >
                        <div
                            className={styles.mutedText}
                            style={{
                                marginBottom: 8,
                                fontSize: "14px",
                                color: "#8c8c8c"
                            }}
                        >
                            {statusName}
                        </div>
                        <div
                            className={styles.statValue}
                            style={{
                                fontSize: "28px",
                                fontWeight: "bold",
                                color: color,
                                lineHeight: 1
                            }}
                        >
                            {count}
                        </div>
                    </div>
                </Col>
            )
        }
        return (
            <>
                {/* Enrollment Stats */}
                <Row gutter={16} type="flex" style={{ marginBottom: 0 }}>
                    {
                        (enrollmentStatusArr || []).filter((s) => s && s.statusName).map((enrollment, index) => {
                            const spanSize = (24 / enrollmentStatusArr.length);
                            return getStatCard(enrollment, index, spanSize)
                        })
                    }
                </Row>

                {/* Invoice Status */}
            </>
        )
    }
}


export default ClaimDeskStats;